module.exports = __webpack_public_path__ + "img/xhs_down.29e78bee.png";